import LocalizedStrings from 'localized-strings';

import { Quarter } from '../../../types';

const locales = new LocalizedStrings({
  en: {
    custom: 'Custom period',
    dateFormat: 'en-US',
    quarter: {
      [Quarter.FIRST]: '1st quarter {year}',
      [Quarter.SECOND]: '2nd quarter {year}',
      [Quarter.THIRD]: '3rd quarter {year}',
      [Quarter.FOURTH]: '4th quarter {year}',
    },
  },
  fr: {
    custom: 'Plage de dates personnalisées',
    dateFormat: 'fr',
    quarter: {
      [Quarter.FIRST]: '1er trim. {year}',
      [Quarter.SECOND]: '2ème trim. {year}',
      [Quarter.THIRD]: '3ème trim. {year}',
      [Quarter.FOURTH]: '4ème trim. {year}',
    },
  },
} as const);

export default locales;
